/**
 * Created by liuzhq on 2018/12/4.
 */
import Vue from 'vue'
import Inter from './vue-internationalization'

Vue.use(Inter)

export default new Inter({
  lang: navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage),
  langWords: {
    "连接断开":{
      "zh-CN": "连接断开",
      "zh": "连接断开",
      "en": "Connection interrupted",
      "ru": "Подключение отключено",
      "ja": "接続が中断されました",
      "ko": "연결 끊기",
      "zh-TW": "連線斷開",
    },
    "即将重连":{
      "zh-CN": "即将重连",
      "zh": "连接断开",
      "en": "Reconnecting…",
      "ru": "Подключается",
      "ja": "まもなく再度接続します",
      "ko": "곧 다시 연결하기",
      "zh-TW": "即將重連",
    },
    "已连接":{
      "zh-CN": "已连接",
      "zh": "已连接",
      "en": "Connection succeeded",
      "ru": "Подключено",
      "ja": "接続できました",
      "ko": "연결 완료",
      "zh-TW": "已連線",
    },
    "连接中": {
      "zh-CN": "连接中",
      "zh": "连接中",
      "en": "connecting",
      "ru": "В связи",
      "ja": "接続中",
      "ko": "연결 중",
      "zh-TW": "連接中",
    },
    "正在直播":{
      "zh-CN": "正在直播",
      "zh": "正在直播",
      "en": "Live",
      "ru": "Лайф идёт",
      "ja": "生放送中",
      "ko": "생방송 중입니다",
      "zh-TW": "正在直播",
    },
    "直播已结束":{
      "zh-CN": "直播已结束",
      "zh": "直播已结束",
      "en": "Live broadcast is over.",
      "ru": "Лайф закончился",
      "ja": "生放送が終了しました",
      "ko": "생방송 완료",
      "zh-TW": "直播已結束",
    },
    "直播已失效":{
      "zh-CN": "直播已失效",
      "zh": "直播已失效",
      "en": "Live broadcast has expired.",
      "ru": "Лайф недействителен",
      "ja": "生放送が無効になりました",
      "ko": "생방송 무효",
      "zh-TW": "直播已失效",
    },
    "主播暂时离开或网络出错":{
      "zh-CN": "主播暂时离开或网络出错",
      "zh": "主播暂时离开或网络出错",
      "en": "The host/hostess has temporarily left, or there is an error with the network.",
      "ru": "Хозяин временно уходит или ошибка сети",
      "ja": "アンカーがしばらく席を外しているもしくはインターネットの接続が不安定です",
      "ko": "앵커 잠시 나가거나 혹은 인터텟 연결이 안됩니다.",
      "zh-TW": "主播暫時離開或網絡出錯",
    },
    "正在获取历史消息":{
      "zh-CN": "正在获取历史消息",
      "zh": "正在获取历史消息",
      "en": "Obtaining message history…",
      "ru": "Бывшие сообщения получаются",
      "ja": "歴史メッセージを読み込んでいます",
      "ko": "기록 확보 중입니다",
      "zh-TW": "正在獲取歷史消息",
    },
    "直播连接中，请稍后":{
      "zh-CN": "直播连接中，请稍后",
      "zh": "直播连接中，请稍后",
      "en": "Connecting to the live broadcast, please hold on.",
      "ru": "Лайф подключается, подождите",
      "ja": "生放送に接続中。少々お待ちください",
      "ko": "생방송 중입니다. 잠시만 기다려 주세요.",
      "zh-TW": "直播連線中, 請稍後",
    },
    "举报":{
      "zh-CN": "举报",
      "zh": "举报",
      "en": "Report",
      "ru": "Разоблачить",
      "ja": "通報",
      "ko": "신고",
      "zh-TW": "舉報",
    },
    "您可以详细说明举报原因（100字内）":{
      "zh-CN": "您可以详细说明举报原因（100字内）",
      "zh": "您可以详细说明举报原因（100字内）",
      "en": "You can describe in detail your reason of reporting. (No more than 100 words)",
      "ru": "Расскажите причину разоблачения (не больше 100 слов)",
      "ja": "通報の理由を詳しく説明頂けますか（100文字以内）",
      "ko": "신고 원인을 자세히 말씀해 주세요(100자이내)",
      "zh-TW": "閣下可以詳細說明舉報原因 (100 字內)",
    },
    "政治敏感":{
      "zh-CN": "政治敏感",
      "zh": "政治敏感",
      "en": "Politically sensitive",
      "ru": "О политике",
      "ja": "政治的な内容",
      "ko": "정치적으로 민감한 내용",
      "zh-TW": "政治敏感",
    },
    "违法犯罪":{
      "zh-CN": "违法犯罪",
      "zh": "违法犯罪",
      "en": "Illegal",
      "ru": "Незаконное преступление",
      "ja": "違法・犯罪",
      "ko": "불법행위",
      "zh-TW": "違法犯罪",
    },
    "色情低俗":{
      "zh-CN": "色情低俗",
      "zh": "色情低俗",
      "en": "Obscene",
      "ru": "Эротический",
      "ja": "違法・犯罪",
      "ko": "야한 내용",
      "zh-TW": "色情低俗",
    },
    "造谣欺诈":{
      "zh-CN": "造谣欺诈",
      "zh": "造谣欺诈",
      "en": "Scandalous & Fraudulent",
      "ru": "Обман",
      "ja": "デマ・詐欺",
      "ko": "헛소문과 사기",
      "zh-TW": "造謠欺詐",
    },
    "侮辱谩骂":{
      "zh-CN": "侮辱谩骂",
      "zh": "侮辱谩骂",
      "en": "Insulting",
      "ru": "Ругание",
      "ja": "誹謗中傷",
      "ko": "모욕과 욕설",
      "zh-TW": "侮辱謾罵",
    },
    "其他问题":{
      "zh-CN": "其他问题",
      "zh": "其他问题",
      "en": "Other issues",
      "ru": "Другие",
      "ja": "その他",
      "ko": "다른 문제",
      "zh-TW": "其他問題",
    },
    "请选择举报原因":{
      "zh-CN": "请选择举报原因",
      "zh": "请选择举报原因",
      "en": "Please select a reason for your reporting.",
      "ru": "Выберите причину разоблачения",
      "ja": "通報の理由を選んでください",
      "ko": "신고 원인 선택해 주세요",
      "zh-TW": "請選擇舉報原因",
    },
    "举报成功，我们会及时处理":{
      "zh-CN": "举报成功，我们会及时处理",
      "zh": "举报成功，我们会及时处理",
      "en": "Reported successfully, we will attend to it promptly.",
      "ru": "Спасибо, мы посмотрим как можно скорее",
      "ja": "通報を正しく受け取りました。できるだけ早く対応するようにします",
      "ko": "신고가 받았습니다.바로 처리하겠습니다.",
      "zh-TW": "舉報成功, 我們會及時處理",
    },
    "有道翻译官同传直播":{
      "zh-CN": "有道翻译官同传直播",
      "zh": "有道翻译官同传直播",
      "en": "Dear Translate Live Broadcast",
      "ru": 'Лайф синхронного перевода в "Dear Translate"',
      "ja": "Dear Translate同時通訳生中継",
      "ko": "Dear Translate의 동시통역 생방송",
      "zh-TW": "Dear Translate同傳直播",
    },
    "人观看": {
      "zh-CN": "${TT}人观看",
      "zh": "${TT}人观看",
      "en": "${TT}viewers",
      "ru": '${TT}зритель',
      "ja": "視聴者${TT}人",
      "ko": "${TT}명의 시청자",
      "zh-TW": "${TT}人觀看",
    },
    "有道翻译官":{
      "zh-CN": "有道翻译官",
      "zh": "有道翻译官",
      "en": "Dear Translate",
      "ru": 'Dear Translate',
      "ja": "Dear Translate",
      "ko": "Dear Translate",
      "zh-TW": "Dear Translate",
    },
    "立即体验":{
      "zh-CN": "立即体验",
      "zh": "立即体验",
      "en": "Try now",
      "ru": 'Попробовать',
      "ja": "今すぐ体験",
      "ko": "체험하기",
      "zh-TW": "馬上體驗",
    },
    "继续":{
      "zh-CN": "继续",
      "zh": "继续",
      "en": "Continue",
      "ru": 'Продолжить',
      "ja": "次へ",
      "ko": "계속하기",
      "zh-TW": "繼續",
    },
    "取消":{
      "zh-CN": "取消",
      "zh": "取消",
      "en": "Cancel",
      "ru": 'Отменить',
      "ja": "取り消し",
      "ko": "취소",
      "zh-TW": "取消",
    },
    "确认举报该直播间么？":{
      "zh-CN": "确认举报该直播间么？",
      "zh": "确认举报该直播间么？",
      "en": "Are you sure to report this live broadcast room?",
      "ru": 'Хотите разоблачить эту лайф-комнату?',
      "ja": "このライブルームを通報しますか？",
      "ko": "이 생방송실을 신고하시겠습니까?",
      "zh-TW": "是否確認舉報該直播間？",
    },
    "正在进入翻译同传页面":{
      "zh-CN": "正在进入翻译同传页面",
      "zh": "正在进入翻译同传页面",
      "en": "Entering the Simultaneous Interpreter page…",
      "ru": 'В страницу синхронного перевода',
      "ja": "同時通訳画面に移行しています",
      "ko": "동시통역 생방송에 들어가고 있습니다",
      "zh-TW": "正在進入翻譯同傳頁面",
    },
    "扫码进入直播":{
      "zh-CN": "扫码进入直播",
      "zh": "扫码进入直播",
      "en": "Scan the QR Code to enter the live broadcast room.",
      "ru": 'Сканируйте QR-код для лайфа',
      "ja": "スキャンして生放送を見ます",
      "ko": "코드를 스캔하여 생방송에 들어가기",
      "zh-TW": "掃碼進入直播",
    },
    "请输入加入码":{
      "zh-CN": "扫码进入直播",
      "zh": "扫码进入直播",
      "en": "Scan the QR Code to enter the live broadcast room.",
      "ru": 'Сканируйте QR-код для лайфа',
      "ja": "スキャンして生放送を見ます",
      "ko": "코드를 스캔하여 생방송에 들어가기",
      "zh-TW": "掃碼進入直播",
    },
    "进入直播":{
      "zh-CN": "进入直播",
      "zh": "进入直播",
      "en": "Enter the live broadcast room",
      "ru": 'Войти в лайф',
      "ja": "生放送を見ます",
      "ko": "생방송에 들어가기",
      "zh-TW": "進入直播",
    },
    "识别失败，请重试":{
      "zh-CN": "识别失败，请重试",
      "zh": "识别失败，请重试",
      "en": "Recognition failed, please try again.",
      "ru": 'Не удалось сканировать, повторите',
      "ja": "識別できませんでした。再度試してみてください",
      "ko": "인식 실패했습니다. 다시 시도해 보세요.",
      "zh-TW": "識別失敗, 請重試",
    },
    "非有道同传二维码":{
      "zh-CN": "非有道同传二维码",
      "zh": "非有道同传二维码",
      "en": "This is not a QR code for Youdao Simultaneous Interpreter.",
      "ru": 'Это не QR-кода из YOUDAO синхронного перевода',
      "ja": "Youdao同時通訳のQRコードではありません",
      "ko": "유다오 동시통역에 관련된 QR코드가 아닙니다.",
      "zh-TW": "非有道同傳二維碼",
    },
    "加入码错误或直播已结束":{
      "zh-CN": "加入码错误或直播已结束",
      "zh": "加入码错误或直播已结束",
      "en": "Invitation code error or the live broadcast is over.",
      "ru": 'Ошибка кода приглашения или лайф закончился',
      "ja": "間違った参加コードもしくは終了した生放送です",
      "ko": "가입코드 오류 혹은 생방송 완료",
      "zh-TW": "加入碼錯誤或直播已結束",
    },
    "加入失败，请重试":{
      "zh-CN": "加入失败，请重试",
      "zh": "加入失败，请重试",
      "en": "Failed to join, please try again.",
      "ru": 'Не удалось войти, повторите',
      "ja": "参加できませんでした。再度試してみてください",
      "ko": "가입 살패했습니다. 다시 시도해 보세요.",
      "zh-TW": "加入失敗, 請重試",
    },
    "提交":{
      "zh-CN": "提交",
      "zh": "提交",
      "en": "submit",
      "ru": 'представить',
      "ja": "提出する",
      "ko": "제출",
      "zh-TW": "遞交",
    },
  }
})


// WEBPACK FOOTER //
// ./src/plugins/inter.js